import { Stack, usePathname } from 'expo-router';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { useEnableNativeTabBarExperiment } from 'experiments/use-enable-native-tab-bar-experiment';
import { useNativeTabBarContentInset } from 'hooks/use-native-tab-bar-content-inset';
import { PromoMessageRibbon } from 'pages/loyalty/loyalty-promo-message-ribbon';
import { primitive } from 'styles/constants';

export default function RewardsLayout() {
  const pathname = usePathname();
  // The native (Liquid Glass) tab bar has no header slot like the classic `Tabs`
  // screenOptions.header does, so this screen must render its own header when treatment is active.
  const { isTreatment: isNativeTabBarEnabled } = useEnableNativeTabBarExperiment();
  const nativeTabBarContentInset = useNativeTabBarContentInset();

  const isIncentiveSelected = pathname && !!pathname.split('/')[3];

  return (
    <>
      {isNativeTabBarEnabled ? <StandardMobileHeader useNativeTabsRootSafeAreaInset /> : null}
      {!isIncentiveSelected && <PromoMessageRibbon skipStoreDayPartHours />}
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: primitive.$mayoEggWhite },
        }}
      >
        <Stack.Screen name="index" options={{ animation: 'none' }} />
        <Stack.Screen name="history" options={{ animation: 'none' }} />
        <Stack.Screen name="profile" options={{ animation: 'none' }} />
        <Stack.Screen name="activate-challenge" />
        {/* NOTE: modals are in (modals) */}
      </Stack>
      <FloatingViewCartFab extraBottomInset={nativeTabBarContentInset} />
    </>
  );
}
